export default "__VITE_ASSET__85c99d9c__"